import React from "react";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import { CssTextField } from "../styles/styles";
import { useNavigate } from "react-router-dom";
import { Padding, PaletaColor } from "../styles/StylesConstantes";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Edit } from "@mui/icons-material";


function TransaccionDataClienteComponents({ name, cedula, apellido, email, telefono, handleVolverEditar }) {

    let history = useNavigate();






    return (
        <div style={{
            backgroundColor: PaletaColor.BLANCO,
            borderRadius: Padding.P1,
            padding: Padding.P3,
        }}>
            <div style={{}}>
                <Typography variant={'h6'} style={{}}>
                    Crear transacción
                </Typography>
                <Typography variant={'h6'} style={{ marginTop: Padding.P2, fontWeight: 'bold' }}>
                    Datos del cliente
                </Typography>
            </div>


            <div style={{ marginTop: Padding.P2 }} >
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{ fontWeight: 'bold' }}>
                                Cliente
                            </Typography>

                            <Typography variant={'subtitle1'} style={{}}>
                                {name} {apellido}
                            </Typography>
                        </div>
                    </div>



                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{ fontWeight: 'bold' }}>
                                Cédula de identidad
                            </Typography>

                            <Typography variant={'subtitle1'} style={{}}>
                                {cedula}
                            </Typography>
                        </div>
                    </div>

                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{ fontWeight: 'bold' }}>
                                Email
                            </Typography>

                            <Typography variant={'subtitle1'} style={{}}>
                                {email}
                            </Typography>
                        </div>
                    </div>

                    <div style={{ flex: 1 }}>
                        <div>
                            <Typography variant={'subtitle1'} style={{ fontWeight: 'bold' }}>
                                Teléfono
                            </Typography>

                            <Typography variant={'subtitle1'} style={{}}>
                                {telefono}
                            </Typography>
                        </div>
                    </div>

                    <div style={{ flex: 1 }}>
                        <div style={{
                            border: '1px solid #E0E0E0',
                            borderRadius: Padding.P1,
                            padding: Padding.P1,
                            display: 'flex',
                            flexDirection: 'row',
                            width: 60,
                            justifyContent: 'center'
                        }}>
                            <IconButton aria-label="edit" size="large" onClick={() => handleVolverEditar()}>
                                <Edit />
                            </IconButton>
                        </div>
                    </div>
                </div>


            </div>

        </div>
    )
}

export default TransaccionDataClienteComponents;